import { emojiDictionary } from '@/services/MessageService'

export default {
  data () {
    return {
			reactions: [
				{ title: 'BH heart', type: 'bh-heart.svg' },
				{ title: 'Like', type: emojiDictionary.find(emoji => emoji.key === ':)').value },
				{ title: 'Smile', type: emojiDictionary.find(emoji => emoji.key === ':]').value },
				{ title: 'Surprised', type: emojiDictionary.find(emoji => emoji.key === ':O').value },
				{ title: 'Sad', type: emojiDictionary.find(emoji => emoji.key === ':\'(').value },
				{ title: 'Angry', type: emojiDictionary.find(emoji => emoji.key === '>:(').value },
				{ title: 'Thumb up', type: emojiDictionary.find(emoji => emoji.key === ':thumbs-up').value },
				{ title: 'Thumb down', type: emojiDictionary.find(emoji => emoji.key === ':thumbs-down').value }
			]
    }
  }
}
